export default "__VITE_ASSET__CkrrBShu__"